export default __webpack_public_path__ + "static/media/dummy_pawn_black.acf683a9.svg";